App.prototype.pageDetector = function (pageName, init) {
    if($('.'+pageName).length) {
        init();
    }
};
